import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Checkbox.css';
import { ThemeSetup } from '../../themes/ThemeSetup';
import ToolTip from '../AssetPropertyView';

const Checkbox = ({ checked, label, onChange, tooltip = undefined, disabled = false }) => {
  const labelUI = label ? (
    <ToolTip text={tooltip}>
      <span
        className={disabled ? 'label disabled' : 'label'}
        onClick={() => onChange({ target: { checked: !checked } })}>
        {label}
      </span>
    </ToolTip>
  ) : null;

  const checkboxUI = (
    <ToolTip text={tooltip}>
      <input
        type="checkbox"
        name="Checkbox"
        checked={checked}
        className={classNames({ checked })}
        onChange={onChange}
        disabled={disabled}
        onClick={(e) => e.stopPropagation()}
        style={{ backgroundImage: checked ? ThemeSetup.getBackgroundURL('checkbox_white.svg') : null }}
      />
    </ToolTip>
  );

  return labelUI ? (
    <div name="Checkbox" className={classNames({ checked })}>
      {checkboxUI}
      {labelUI}
    </div>
  ) : (
    checkboxUI
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  tooltip: PropTypes.string
};

export default Checkbox;
